import { array, boolean, enums, type Infer, instance, nullable, object, string } from "superstruct";

import { CredentialType } from "@mpa/platform/enums/CredentialType";
import { Permission } from "@mpa/platform/enums/Permission";

import getEnumValues from "../enums/getEnumValues.js";
import { Problem } from "../error/Problem.js";
import { isoDate } from "../scalar_types/isoDate.js";
import { ProjetSchema } from "./Projet.js";

export const UserSerializedSchema = object({
    id: string(),
    permissions: array(enums(getEnumValues(Permission))),
});

export type UserSerialized = Infer<typeof UserSerializedSchema>;

export class User {
    constructor(
        readonly id: string,
        readonly permissions: Permission[],
    ) {}

    hasPermission(permission: Permission) {
        return this.permissions.includes(permission);
    }

    assertHasPermission(permission: Permission) {
        if (!this.hasPermission(permission)) {
            throw new Problem("Vous n'avez pas la permission d'effectuer cette action");
        }
    }

    serialize(): UserSerialized {
        return { id: this.id, permissions: this.permissions };
    }

    static deserialize(data: UserSerialized): User {
        return new User(data.id, data.permissions);
    }
}

export const UserSchema = instance(User);

export const UserListItemSchema = object({
    id: string(),
    self: boolean(),
    label: string(),
    lastUsedAt: nullable(isoDate),
});

export const UserCredentialSchema = object({
    type: enums(getEnumValues(CredentialType)),
    key: string(),
});

export const UserLoginSchema = object({
    id: string(),
    device: string(),
    createdAt: isoDate,
    lastUsedAt: isoDate,
    invalidatedAt: nullable(isoDate),
    current: boolean(),
});

export const UserDetailSchema = object({
    id: string(),
    self: boolean(),
    permissions: array(enums(getEnumValues(Permission))),
    credentials: array(UserCredentialSchema),
    logins: array(UserLoginSchema),
    projets: array(ProjetSchema),
});

export type UserListItem = Infer<typeof UserListItemSchema>;
export type UserCredential = Infer<typeof UserCredentialSchema>;
export type UserLogin = Infer<typeof UserLoginSchema>;
export type UserDetail = Infer<typeof UserDetailSchema>;
